import type { FaireProductEntity } from "../../entity_types/product";

export const p_pj8qarvdk9: FaireProductEntity = {
  token: "p_pj8qarvdk9",
  type: "product",
  name: "Hold On, Let Me Overthink This… Essential Oil Roller",
  brandToken: "b_r5xk4t473s",
  brandName: "Blue Sage",
  imageUrl:
    "https://cdn.faire.com/fastly/39b61bb2d845a6363e8d46aaa59b0ab6ae2cca107957106cf76e1975fbdfbc45.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/74db396d974ce58caa86c54e51d06be4bf08e7e05c99f3e742e79c6340d11b75.jpeg",
    "https://cdn.faire.com/fastly/0bb3197d6b3004ccc031ac28dcc9833af95e8280c243165ed8e786036eb4ea11.jpeg",
    "https://cdn.faire.com/fastly/28c96613a0811d5048d82aa517c536891a54a272c54274a0b64f1e0ef296f8b6.jpeg",
    "https://cdn.faire.com/fastly/a5230db975c29fff42bb62d4d80be43940e7128d7082730ddd4c6d2af0a340aa.jpeg",
    "https://cdn.faire.com/fastly/e55f85fee05a89b3f3a2bcc9395bc21250133acbe5074ee24edaaa5bcf91c47b.png",
  ],
  priceDollars: 6.93,
  description:
    "Hold On, Let Me Overthink This...  | Essential Oil Roller\n\nAhh, anxiety.  How could we not have a roller blend for this one. We don’t want you to actually overthink the situation that’s smaller than a grain of sand, but sometimes acknowledging the anxious thought and correlating it with a positive experience like the scent of this roller is all you need to kick it.  And remember, were all just bits of stardust wobbling around a humungous space rock in the middle of nowhere.  Or are we…\n\nBLEND: Black Spruce, Frankincense, Ho Wood, Geranium, and Chamomile in Fractionated Coconut Oil.\n\nAll of our oil blends are crafted right here by us in our studio!  \n\nTo Use: Roll on pulse points such as wrists, inside elbows, temples, bend of knee, ankles, soles of feet, back of neck.",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:28.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
